import { BrowserRouter, Routes, Route } from "react-router-dom";
import RootLayout from "./app/layout";
import { AdminLayout } from "./components/layouts/AdminLayout";
import HomePage from "./app/page";
import LoginPage from "./app/login/page";
import CustomersPage from "./app/customers/page";
import VehiclesPage from "./app/vehicles/page";
import PackagesPage from "./app/packages/page";
import AppointmentsPage from "./app/appointments/page";
import NewAppointmentPage from "./app/appointments/new/page";
import SubscriptionsPage from "./app/subscriptions/page";
import BillingPage from "./app/billing/page";
import ReportsPage from "./app/reports/page";
import StaffManagementPage from "./app/staff-management/page";
// import SettingsPage from "./app/settings/page";
import ActivityPage from "./app/activity/page";
import StaffActivityPage from "./app/staff-activity/page";
import StaffTimeTrackingPage from "./app/staff-time-tracking/page";
import StaffLayout from "./app/staff/layout";
import StaffDashboardPage from "./app/staff/dashboard/page";
import ReceiptPage from "./app/receipt/page";
import { ProtectedRoute } from "./components/routing/ProtectedRoute";
import { ErrorBoundary } from "./components/common/ErrorBoundary";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/login"
          element={
            <RootLayout>
              <LoginPage />
            </RootLayout>
          }
        />
        <Route
          path="/receipt/:paymentId"
          element={
            <RootLayout>
              <ReceiptPage />
            </RootLayout>
          }
        />
        <Route
          path="/staff/dashboard"
          element={
            <ProtectedRoute>
              <RootLayout>
                <StaffLayout>
                  <ErrorBoundary>
                    <StaffDashboardPage />
                  </ErrorBoundary>
                </StaffLayout>
              </RootLayout>
            </ProtectedRoute>
          }
        />
        {/* Admin routes with shared sidebar layout */}
        <Route
          element={
            <ProtectedRoute>
              <RootLayout>
                <AdminLayout />
              </RootLayout>
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<HomePage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/vehicles" element={<VehiclesPage />} />
          <Route path="/packages" element={<PackagesPage />} />
          <Route path="/appointments" element={<AppointmentsPage />} />
          <Route path="/appointments/new" element={<NewAppointmentPage />} />
          <Route path="/subscriptions" element={<SubscriptionsPage />} />
          <Route path="/billing" element={<BillingPage />} />
          <Route path="/reports" element={<ReportsPage />} />
          <Route path="/staff-management" element={<StaffManagementPage />} />
          <Route path="/staff-time-tracking" element={<StaffTimeTrackingPage />} />
          {/* <Route path="/settings" element={<SettingsPage />} /> */}
          <Route path="/activity" element={<ActivityPage />} />
          <Route path="/staff-activity" element={<StaffActivityPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
